//bao migrate skip
import * as ko from "knockout";
import Bao from "./../services/bao-service";
import * as $ from "jquery";
import * as moment from "moment";
var bindingName = "baoDateTimeBox";

export class DateTimeBoxBinding {
    constructor(element: HTMLElement, valueAccessor: () => Bindings.baoDateTimeBox, allBindingsAccessor?: any, viewModel?: any) {
        this.Element = element;
        this.Config = valueAccessor();
        this.AllBindingsAccessor = allBindingsAccessor;
        this.ViewModel = viewModel;
        $(this.Element).data(bindingName, this);
        //subscribes
        this._subscribes.push(this.Config.value.subscribe((newValue) => {
            this.UpdateObservable(newValue);
        }));
        this._subscribes.push(this.IgnoreChange.subscribe((newValue) => {
            if (newValue) {
                $(this.Element).attr("data-ignore", "true");
            }
            else {
                $(this.Element).removeAttr("data-ignore");
            }
        }));
        if (ko.isObservable(this.Config.minDate)) {
            this._subscribes.push(this.Config.minDate.subscribe((minDate) => {
                var newDate = this.CheckMinRestriction(minDate);
                if (newDate != null) {
                    this.Config.value(newDate);
                }
            }));
        }
        if (ko.isObservable(this.Config.maxDate)) {
            this._subscribes.push(this.Config.maxDate.subscribe((maxDate) => {
                var newDate = this.CheckMaxRestriction(maxDate);
                if (newDate != null) {
                    this.Config.value(newDate);
                }
            }));
        }
        //events auf Element
        $(element).change((e) => {
            if (this.IgnoreChange() == false) {
                this.RefreshOptions();
                this.ParseInput($(this.Element).val());
            }
        });
        //Init value
        this.RefreshOptions();
        this.setCultureOptions();
        this.UpdateObservable(this.Config.value());
    }
    private _subscribes: KnockoutSubscription[] = [];
    IgnoreChange = ko.observable<boolean>(false);
    Element: HTMLElement;
    AllBindingsAccessor: any;
    ViewModel: any;
    Mode: string;
    Culture: string;
    Config: Bindings.baoDateTimeBox;
    PossibleFormat: string[];
    Format: string;
    InitDate: moment.Moment;
    MomentDate: moment.Moment;
    //functions
    UpdateObservable(newValue: string) {
        if (this.IgnoreChange() == false) {
            this.MomentDate = moment(newValue, Bao.Utils.DateTimeFormat);
            this.RefreshOptions();
            if (this.MomentDate != null && this.MomentDate.isValid()) {
                $(this.Element).val(this.MomentDate.format(this.Format));
                //if (initDate == null) {
                this.InitDate = this.MomentDate.clone();
                //}
            }
            else {
                $(this.Element).val("");
            }
        }
    }
    RefreshOptions() {
        this.Mode = ko.unwrap(this.Config.mode);
        if (this.Mode == "" || this.Mode == null) {
            this.Mode = "date";
        }
        this.Culture = ko.unwrap(this.Config.culture);
        if (this.Culture == "") {
            this.Culture = "de-DE";
        }
        setTimeout(() => {
            this.setCultureOptions();
        }, 0);
    }
    ;
    private setCultureOptions() {
        var m = moment();
        m.locale(this.Culture.substring(0, 2));
        // HACK: typing stimmt nicht mit unserer verwendeten moment version überein => convert "as any"!s
        var localeData = m.localeData() as any;
        switch (this.Mode) {
            case "time":
                this.PossibleFormat = [localeData.longDateFormat("LTS"), localeData.longDateFormat("LT")]; //LTS, LT
                this.Format = localeData.longDateFormat("LT");
                break;
            case "datetime":
                this.PossibleFormat = [localeData.longDateFormat("L") + " " + localeData.longDateFormat("LT"), localeData.longDateFormat("L")]; //L + LT, L
                this.Format = localeData.longDateFormat("L") + " " + localeData.longDateFormat("LT");
                break;
            case "datetimesec":
                this.PossibleFormat = [
                    localeData.longDateFormat("L") + " " + localeData.longDateFormat("LTS"),
                    localeData.longDateFormat("L") + " " + localeData.longDateFormat("LT"),
                    localeData.longDateFormat("L")
                ];
                this.Format = localeData.longDateFormat("L") + " " + localeData.longDateFormat("LTS");
                break;
            case "date":
                this.PossibleFormat = [localeData.longDateFormat("L")];
                this.Format = localeData.longDateFormat("L");
                break;
            case "custom":
                this.PossibleFormat = ko.unwrap(this.Config.customFormatTryParse);
                this.Format = ko.unwrap(this.Config.customFormat);
                break;
        }
    }
    ParseInput(value) {
        this.MomentDate = null;
        $.each(this.PossibleFormat, (index, item) => {
            var m = moment(value, item);
            if (m != null && m.isValid()) {
                var arr = value.replace(/\./g, ",").split(',');
                if (arr.length == 3) {
                    var timePart = arr[2].split(' ')[1];
                    var yearPart = arr[2].split(' ')[0];
                    if (timePart == null) {
                        timePart = "";
                    }
                    var dateTimeValue = "";
                    if (yearPart.length == 4) {
                        dateTimeValue = value;
                    }
                    else if (yearPart.length == 3) {
                        dateTimeValue = arr[0] + "," + arr[1] + ",0" + arr[2];
                    }
                    else if (yearPart.length == 2) {
                        dateTimeValue = arr[0] + "," + arr[1] + ",20" + arr[2];
                    }
                    else if (yearPart.length == 1) {
                        dateTimeValue = arr[0] + "," + arr[1] + ",200" + arr[2];
                    }
                    else if (yearPart.length == 0) {
                        dateTimeValue = arr[0] + "," + arr[1] + "," + new Date().getFullYear();
                    }
                    if (dateTimeValue != "") {
                        var customFormat = Bao.Utils.DateDisplayFormat;
                        if (timePart != "" && timePart.length == 5) {
                            customFormat = Bao.Utils.DateTimeDisplayFormat;
                        }
                        else if (timePart != null && timePart.length == 8) {
                            customFormat = Bao.Utils.DateTimeDisplayFormat;
                        }
                        m = moment(dateTimeValue, customFormat);
                    }
                }
                else if (arr.length == 2) {
                    value = arr[0] + "," + arr[1] + "," + new Date().getFullYear();
                    m = moment(value, Bao.Utils.DateDisplayFormat);
                }
                if (m.isValid()) {
                    this.MomentDate = m;
                    return false;
                }
            }
        });
        if (this.MomentDate == null) {
            $(this.Element).val("");
            if (ko.isObservable(this.Config.value)) {
                this.IgnoreChange(true);
                this.Config.value(null);
                this.IgnoreChange(false);
            }
        }
        else {
            if (this.Mode == "time" && this.InitDate != null) {
                this.MomentDate.year(this.InitDate.year());
                this.MomentDate.month(this.InitDate.month());
                this.MomentDate.date(this.InitDate.date());
            }
            $(this.Element).val(this.MomentDate.format(this.Format));
            if (ko.isObservable(this.Config.value)) {
                this.IgnoreChange(true);
                this.Config.value(this.MomentDate.format(Bao.Utils.DateTimeFormat));
                this.IgnoreChange(false);
            }
        }
    }
    CheckMinRestriction(minDate: string): string {
        var currentDateTime = moment(this.Config.value.peek(), Bao.Utils.DateTimeFormat);
        if (minDate && currentDateTime) {
            var minDateTime = moment(minDate, Bao.Utils.DateTimeFormat);
            if (minDateTime.isValid() && currentDateTime.isValid()) {
                if (currentDateTime < minDateTime) {
                    return minDateTime.format(Bao.Utils.DateTimeFormat);
                }
            }
        }
        return null;
    }
    ;
    CheckMaxRestriction(maxDate) {
        var currentDateTime = moment(this.Config.value.peek(), Bao.Utils.DateTimeFormat);
        if (maxDate && currentDateTime) {
            var maxDateTime = moment(maxDate, Bao.Utils.DateTimeFormat);
            if (maxDateTime.isValid() && currentDateTime.isValid()) {
                if (currentDateTime > maxDateTime) {
                    return maxDateTime.format(Bao.Utils.DateTimeFormat);
                }
            }
        }
        return null;
    }
    ;
    dispose() {
        for (var i = 0; i < this._subscribes.length; i++) {
            this._subscribes[i].dispose();
        }
        $(this.Element).removeData(bindingName);
    }
}
var baoDateTimeBoxBinding: KnockoutBindingHandler = {
    init: function (element: HTMLElement, valueAccessor, allBindingsAccessor, viewModel) {
        var bindingInstance = new DateTimeBoxBinding(element, valueAccessor, allBindingsAccessor, viewModel);
        ko.utils.domNodeDisposal.addDisposeCallback(element, () => {
            bindingInstance.dispose();
        });
    }
};
ko.bindingHandlers[bindingName] = baoDateTimeBoxBinding;